import { cva } from '@vizit/theme';

export const switchClasses = cva({
  base: 'group inline-flex items-center gap-4 text-sm font-medium text-secondary outline-none data-[disabled]:cursor-not-allowed data-[disabled]:text-disabled',
});

export const trackClasses = cva({
  base: [
    'relative inline-flex h-10 w-18 shrink-0 items-center rounded-full p-1 transition-colors',
    'border border-transparent',
    // Focus ring driven by the Switch root's focus-visible state
    'group-data-[focus-visible]:ring-2 group-data-[focus-visible]:ring-offset-2 group-data-[focus-visible]:ring-brand-600',
  ],
  variants: {
    isSelected: {
      true: 'bg-brand-solid',
      false: 'bg-tertiary border-secondary',
    },
    isDisabled: {
      true: 'opacity-60',
      false: '',
    },
  },
});

export const knobClasses = cva({
  base: 'h-8 w-8 rounded-full bg-primary shadow-sm transition-transform',
  variants: {
    isSelected: {
      true: 'translate-x-8',
      false: 'translate-x-0',
    },
  },
});
